//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { goShopDetail } from "@libs/order";
export default {
  name: "PromotionGood",
  props: {
    benefit: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    // 商品详情跳转
    goDetail: function goDetail(item) {
      var _this = this;

      goShopDetail(item).then(function () {
        _this.$router.push({
          path: "/detail/" + item.id
        });
      });
    }
  }
};